var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#26262C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_13157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5223 7.71747C16.7345 7.47501 16.7099 7.10649 16.4675 6.89434C16.225 6.68219 15.8565 6.70676 15.6443 6.94922L12.6631 10.3563L10.1333 6.98334C10.0232 6.83646 9.85028 6.75 9.66667 6.75H7.33333C7.11238 6.75 6.9104 6.87485 6.81159 7.07247C6.71278 7.27009 6.7341 7.50658 6.86667 7.68334L10.6214 12.6897L7.47766 16.2825C7.26551 16.525 7.29008 16.8935 7.53254 17.1057C7.77499 17.3178 8.14352 17.2933 8.35567 17.0508L11.3369 13.6437L13.8667 17.0167C13.9769 17.1636 14.1497 17.25 14.3333 17.25H16.6667C16.8876 17.25 17.0896 17.1252 17.1884 16.9275C17.2872 16.7299 17.2659 16.4934 17.1333 16.3167L13.3786 11.3103L16.5223 7.71747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_13157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitterBlack.4c00da7f63031af27fe4094942529b62.svg";
export { ForwardRef as ReactComponent };